var _rect, _mask, _path, _tspan, _rect2, _rect3, _tspan2, _rect4, _rect5, _tspan3, _rect6, _rect7, _tspan4, _rect8, _rect9, _tspan5, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrastbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 332,
    viewBox: "0 0 411 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1418_8277)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1418_8277)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 292,
    rx: 10,
    className: "component-background"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1418_8277)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1418_8277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16C20.5 12.6863 23.1863 10 26.5 10H384.5C387.814 10 390.5 12.6863 390.5 16V58H20.5V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H390.5H20.5ZM390.5 59H20.5V57H390.5V59ZM20.5 58V10V58ZM390.5 10V58V10Z",
    fill: "white",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1418_8277)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 42.71
  }, "CONTRAST BUTTON")))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1418_8277)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 68,
    width: 350,
    height: 40,
    rx: 6,
    className: "component-foreground-id",
    shapeRendering: "crispEdges"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 68.5,
    width: 349,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 181.6,
    y: 91.14
  }, "NORMAL")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 128,
    width: 350,
    height: 40,
    rx: 6,
    className: "component-foreground-id"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 128.5,
    width: 349,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.719,
    y: 151.14
  }, "PRESSED")))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1418_8277)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 188,
    width: 350,
    height: 40,
    rx: 6,
    className: "component-foreground-id",
    shapeRendering: "crispEdges"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 187,
    width: 352,
    height: 42,
    rx: 7,
    className: "button-contrast-focus",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 179.66,
    y: 211.14
  }, "FOCUSED")))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 248,
    width: 350,
    height: 40,
    rx: 6,
    className: "component-foreground-id"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 248.5,
    width: 349,
    height: 39,
    rx: 5.5,
    stroke: "white",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-background",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 177.346,
    y: 271.14
  }, "DISABLED"))))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10.5,
    width: 369,
    height: 291,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1418_8277",
    x: 0.5,
    y: 0,
    width: 410,
    height: 332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1418_8277",
    x: 10.5,
    y: 5,
    width: 390,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1418_8277",
    x: 10.5,
    y: 58,
    width: 390,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1418_8277",
    x: 8.5,
    y: 176,
    width: 394,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1418_8277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1418_8277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_8277"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 292,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrastbutton);
export default __webpack_public_path__ + "static/media/contrastbutton.189ea66d22ce0a33a6a0c965c5e334e3.svg";
export { ForwardRef as ReactComponent };